import Answer from 'ef/models/answer';
import Chaplin from 'chaplin';

const AnswersCollection = Chaplin.Collection.extend({
  model: Answer,
});

export default AnswersCollection;
